import { Modal, Select, ModalBar, Title } from '@chillibean/component-library/legacy';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import AssetReporting from '../../../api/reporting/AssetReporting';
import { Reporting } from '../../../api/reporting/reporting';
import useHttpRequest from '../../../CustomHooks/useHttpRequest/useHttpRequest';

function ExportModal(props) {
  // destructure props
  const { showModal, setShowModal, formTemplateID = '', protocolID = '', exportEndpoint, filterParams = {} } = props;

  // state
  const [exportLoading, setExportLoading] = useState(false);
  const [exportFunction, setExportFunction] = useState();
  const [exportSelectValue, setExportSelectValue] = useState('Excel');

  // set variables
  const formsExportEndpoint = Reporting.export({ form_template_id: formTemplateID });
  const assetsExportEndpoint = AssetReporting.export(filterParams);
  const protocolsExportEndpoint = Reporting.exportProtocols(protocolID);

  const {
    state: { status },
    blobDownloadRequest,
  } = useHttpRequest();

  const exportModalBarButtons = [
    {
      name: 'EXPORT',
      handleClick: () => requestExport(),
      disabled: false,
      loading: exportLoading,
    },
    {
      name: 'Cancel',
      handleClick: () => setShowModal(false),
      disabled: false,
      isCancelButton: true,
    },
  ];

  // hooks
  useEffect(() => {
    switch (exportEndpoint) {
      case 'FORMS':
        setExportFunction(formsExportEndpoint);
        break;
      case 'ASSETS':
        setExportFunction(assetsExportEndpoint);
        break;
      case 'SITES':
        setExportFunction(protocolsExportEndpoint);
        break;
      default:
        setExportFunction(formsExportEndpoint);
    }
  }, [exportEndpoint]);

  useEffect(() => {
    if (status === 'resolved') {
      setExportLoading(false);
      setShowModal(false);
    }
  }, [status]);

  // handlers
  function requestExport() {
    setExportLoading(true);
    blobDownloadRequest(exportFunction);
  }

  return (
    <Modal
      showModal={showModal}
      onDismiss={() => {
        setShowModal(false);
      }}
      testId={`${exportEndpoint} Export`}
    >
      <div className="modal__cl--title">
        <Title heading="Export data" subheading="Confirm Action" />
      </div>
      <div data-test-id="export-select">
        <Select options={['Excel']} value={exportSelectValue} handleChange={setExportSelectValue} />
      </div>
      <div className="modal__cl--action-bar">
        <ModalBar buttons={exportModalBarButtons} />
      </div>
    </Modal>
  );
}

export default ExportModal;

// proptype validation
ExportModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  formTemplateID: PropTypes.string,
  protocolID: PropTypes.string,
  exportEndpoint: PropTypes.string.isRequired,
  filterParams: PropTypes.shape({
    all_info_fields_must_match: PropTypes.string,
    relative_upload_time_range: PropTypes.string,
    search_fields: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))),
  }),
};
